
/**
 * DeferUntilModulesLoaded — referans-parite (features/platform/utils/DeferUntilModulesLoaded.ts).
 * Kurulum fonksiyonunu bir sonraki mikro-görev turuna erteler (modüllerin
 * yüklenmesini beklemek için).
 */
export function deferUntilModulesLoaded(setup: () => void): void {
	queueMicrotask(setup);
}
